<span> {{item.cartikelnummer}} - {{item.artbez1}}</span>
<span *ngIf="item.artbez2"> - {{item.artbez2}} </span>
<span *ngIf="item.artbez3"> - {{item.artbez3}} </span>
